import crypto from 'crypto'
import { useEffect } from 'react'
import { Button, Icon, Text, Title } from 'ui'
import { mpowerReferrer, userId, utmParams } from '~/cookie'
import { ROUTES } from '~/eligibility/common/routes'
import { authenticator } from '~/services/auth.server'
import classes from '~/styles/homepage.module.scss'
import { clientDeleteCookie, parseServerCookie } from '~/utils/commonUtils'
import { COOKIELIST_ELIGIBILITY_ROUTE, UTMCOOKIE_LIST } from '~/utils/constant'
import { handleStartApplicationStorageData } from '~/utils/handleStartApplicationStorageData'
import { formatUrlforUtms } from '~/utils/manipulateUtm'
import { setDataLayer } from '~/utils/setDataLayer'

import { ActionIcon, Container, Grid } from '@mantine/core'
import { useLocalStorage } from '@mantine/hooks'
import { ActionFunction, LoaderFunction, json, redirect } from '@remix-run/node'
import { Form, useLoaderData } from '@remix-run/react'

export const loader: LoaderFunction = async ({ request }) => {
  await authenticator.isAuthenticated(request, {
    successRedirect: '/eligibility',
  })
  try {
    const headers = new Headers()
    const cookie = request?.headers?.get('cookie')
    const externalCookieKeyValue = parseServerCookie(cookie ?? '')

    //Handling UTM Logic - formatting the UTMS and storing them in cookie
    const link = new URL(request.url)?.href
    const manipulatedUtmParams = formatUrlforUtms(link, externalCookieKeyValue ?? {})
    headers.append('set-cookie', await utmParams?.serialize(manipulatedUtmParams))

    const url = new URL(request?.url)
    const cookieParse = (await userId?.parse(cookie)) || false

    if (!cookieParse) {
      const randomValue = crypto?.randomBytes(1)
      headers?.append(
        'set-cookie',
        await userId?.serialize({ userID: randomValue?.toString('hex') }),
      )
    }
    return json({}, { headers })
  } catch (error) {
    return json({})
  }
}

export const action: ActionFunction = async ({}) => {
  try {
    return redirect(ROUTES.ELIGIBILITY)
  } catch (error) {
    return false
  }
}

export default function Index() {
  const loaderData = useLoaderData()

  const [, , removeLoggedIn] = useLocalStorage({ key: 'loggedIn', defaultValue: {} })
  const [, , removeAcceptDisclosures] = useLocalStorage({
    key: 'acceptDisclosures',
    defaultValue: {},
  })
  const [, , removeExistUserLocalStorage] = useLocalStorage({
    key: 'existUserLocalStorage',
    defaultValue: { userExist: false },
  })
  const removeFunctions = {
    loggedIn: removeLoggedIn,
    existUserLocalStorage: removeExistUserLocalStorage,
    acceptDisclosures: removeAcceptDisclosures,
  }

  useEffect(() => {
    setDataLayer('user_id')
    try {
      if (document) {
        clientDeleteCookie(['loginPassChange', 'existingUser'] as string[])
        clientDeleteCookie(COOKIELIST_ELIGIBILITY_ROUTE as string[])
        clientDeleteCookie(UTMCOOKIE_LIST as string[])
      }
    } catch (error) {}
  }, [])

  const onStartClick = () => {
    handleStartApplicationStorageData(removeFunctions)
  }

  return (
    <div>
      <Container size="lg" className={classes.mainContainer}>
        <div className={classes.content}>
          <div>
            <div className={classes.batchIconContainer}>
              <Icon name="batch" />
            </div>
            <Title order={1} fontWeight="700" variant="yellow" className={classes.heading}>
              Funding your dream
            </Title>
            <Title order={1} variant="blue" fontWeight="400" className={classes.heading}>
              starts here
            </Title>

            <Grid className="alignLeft">
              <Grid.Col span={{ md: 8, sm: 12 }} offset={{ md: 2, sm: 0 }}>
                <Container pt={30} size="lg" className={classes.highlights} py={7}>
                  <ActionIcon variant="transparent" className={classes.icon}>
                    <Icon name="pen" />
                  </ActionIcon>
                  <Text className={classes.text}>
                    Apply for our no-cosigner loans to study in the U.S. and Canada.
                  </Text>
                </Container>
                <Container size="lg" className={classes.highlights} py={7}>
                  <ActionIcon variant="transparent" className={classes.icon}>
                    <Icon name="passport" />
                  </ActionIcon>
                  <Text className={classes.text}>
                    {`Get your passport ready! You\'ll need it for a faster application process.`}
                  </Text>
                </Container>
                <Container size="lg" className={classes.highlights} py={7}>
                  <ActionIcon variant="transparent" className={classes.collegeIcon}>
                    <Icon name="college" />
                  </ActionIcon>
                  <Text className={classes.text}>
                    It should only take about 20 minutes to complete our application.
                  </Text>
                </Container>
              </Grid.Col>
            </Grid>
            <Grid pt={20} style={{ paddingTop: '0' }} className="fixedCta">
              <Grid.Col>
                <Form method="post" action=".">
                  <Button
                    type="submit"
                    onClick={onStartClick}
                    className={classes.startBtn}
                    size="xl"
                    id={'startApplication'}
                    uppercase={true}
                  >
                    Start Application
                  </Button>
                </Form>
              </Grid.Col>
            </Grid>
          </div>
        </div>
      </Container>
      <div className="svgContainer">
        <Icon name="welcomeWave" />
      </div>
    </div>
  )
}
